import { InteractComponent } from './interact-component';
import $ from 'jquery';

/**
 * Extends the InteractComponent in order to limit the area in which the HTML element
 * can be dragged to the pages container of the Bookviewer - The elemenet can therefore not
 * be moved outside of the book's pages.
 */
export abstract class BoundedInteractComponent extends InteractComponent {

    scrollContainer;

    /**
     * From http://interactjs.io/#resizing
     * @param event
     */
    protected dragEvent(event): void {

        event.stopPropagation();
        const target = event.target;
        let translateX = event.dx;
        let translateY = event.dy;

        const container = $('.pages');

        if (container.length > 0) {
            const rect = target.getBoundingClientRect();
            translateX = Math.min(Math.max(container.offset().left - rect.left, event.dx),
                container.offset().left + container.width() - rect.right);

            translateY = Math.min(Math.max(container.offset().top - rect.top, event.dy),
                container.offset().top + container.height() - rect.bottom);
        }

        const x = (parseFloat(target.getAttribute('data-x')) || 0) + translateX;
        const y = (parseFloat(target.getAttribute('data-y')) || 0) + translateY;

        // translate the element
        target.style.webkitTransform =
            target.style.transform =
                `translate(${x}px, ${y}px)`;

        // update the position attributes
        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
    }
}
